import { pdf } from "@react-pdf/renderer";
import { Packer } from "docx";
import { saveAs } from "file-saver";
import {
    MDBBtn,
    MDBIcon,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle
} from "mdb-react-ui-kit";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { PdfContext } from "../../context/pdf/pdf-context";
import { ResumeContext } from "../../context/resume/resume-context";
import { TranslationContext } from "../../context/translations/translations-context";
import useResumeDocumentSection from "../../hooks/useResumeDocumentSection";
import useResumeProperties from "../../hooks/useResumeProperties";
import { generateWordFileName } from "../../utils/generateWordFileName";
import { buildResumeWordDocument } from "../edition-resume-word/ResumeWord";
import ResumePdf from "./ResumePdf";

export default function ResumePdfDownloadModal() {

    const [ show, setShow ] = useState( false );
    const [ pdfLoading, setPdfLoading ] = useState( false );
    const [ wordLoading, setWordLoading ] = useState( false );

    const { resumeData } = useContext( ResumeContext );
    const { translations } = useContext( TranslationContext );

    const { documentLanguage, keywords } = useResumeProperties();
    const { user } = useResumeDocumentSection();

    const {
        state,
        finalizeDownloadModal,
    } = useContext( PdfContext );

    useEffect( () => {
        setShow( state.isDownloadButtonClicked );
    }, [ state.isDownloadButtonClicked ] );

    function handleClose() {
        setShow( false );
        finalizeDownloadModal();
    }

    async function handlePdfDownload() {
        try {
            setPdfLoading( true );
            const blob = await pdf(
                <ResumePdf resumeData={ resumeData } translations={ translations }/>
            ).toBlob();
            saveAs( blob, state.pdfFileName );
            handleClose();
        } catch ( error ) {
            console.error( "Erreur lors de la génération du document PDF :", error );
            toast.error( translations.pdf.pdfDownloadError );
        } finally {
            setPdfLoading( false );
        }
    }

    async function handleWordDownload() {
        try {
            setWordLoading( true );
            const doc = await buildResumeWordDocument( resumeData, translations );
            const blob = await Packer.toBlob( doc );
            saveAs( blob, generateWordFileName( user, documentLanguage, keywords ) );
            handleClose();
        } catch ( error ) {
            console.error( "Erreur lors de la génération du document Word :", error );
            toast.error( translations.pdf.wordDownloadError );
        } finally {
            setWordLoading( false );
        }
    }

    return (
        <MDBModal show={ show } setShow={ setShow } tabIndex="-1">
            <MDBModalDialog>
                <MDBModalContent>
                    <MDBModalHeader>
                        <MDBModalTitle>{ translations.pdf.downloadModalTitle }</MDBModalTitle>
                        <MDBBtn
                            className="btn-close"
                            color="none"
                            onClick={ handleClose }
                        ></MDBBtn>
                    </MDBModalHeader>

                    <MDBModalBody>{ translations.pdf.downloadModalBody }</MDBModalBody>

                    <MDBModalFooter>
                        <MDBBtn style={ { background: "#97999C" } } onClick={ handleClose }>
                            <MDBIcon fas icon="times"/>
                            { ' ' }
                            { translations.pdf.closeButtonLabel }
                        </MDBBtn>
                        <MDBBtn
                            style={ { background: "#09B4BF" } }
                            disabled={ pdfLoading }
                            onClick={ handlePdfDownload }
                        >
                            <MDBIcon fas icon="file-pdf"/>
                            { ' ' }
                            { pdfLoading ? translations.pdf.loadingLabel : 'PDF' }
                        </MDBBtn>
                        <MDBBtn
                            style={ { background: "#2B579A" } }
                            disabled={ wordLoading }
                            onClick={ handleWordDownload }
                        >
                            <MDBIcon far icon="file-word"/>
                            { ' ' }
                            { wordLoading ? translations.pdf.loadingLabel : 'Word' }
                        </MDBBtn>
                    </MDBModalFooter>
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    );
}
